import { render, staticRenderFns } from "./staff-mock-host.vue?vue&type=template&id=5aa8f8e6&"
import script from "./staff-mock-host.vue?vue&type=script&lang=js&"
export * from "./staff-mock-host.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports